import {promptData, successPromptData} from "../../util/MessageTools";
import {gameItemEnumToString, getGameItemOption, gradeEnumToString, gradeStringToEnum} from '../../util/EnumTransition'
import {mapState} from "vuex";
import api from '../../api'
import router from "../../router";

export default {
  name: 'enterFor',
  computed: mapState([
    'user',
    'enterForPageHint',
    'enterForPageCheck',
    'enterForPageSuccess',
  ]),
  data() {
    return {
      options: [],//参赛栏目的数组
      gradeOptions: [{
        value: "UNDERGRADE",
        label: "本科生",
      }, {
        value: "MASTER",
        label: "硕士研究生",
      }, {
        value: "DOCTOR",
        label: "博士研究生",
      }],
      value: '',
      teacherForm: {//老师信息
        teacherName: "",
        teacherIdCardNo: "",//身份证号
        teacherSchoolName: "",//学校
        teacherCollege: "",//学院
        teacherFieldName: "",//专业
        teacherEmail: "",//邮箱
        teacherTitle: "",//职称
      },
      teacherData: [],//导师的信息
      memberData: [],//成员信息
      playerForm: {//团队成员信息
        teamName: "",
        gameItem: "RES_CITY_SUS_URBAN_DEV",
      },
      memberDialogForm: {//添加成员的dialog
        memberRole: "成员",
        memberName: "",
        idCardNo: "",
        phone: "",
        email: "",
        schoolName: "",
        college: "",
        grade: "",
        fieldName: "",
      },
      teacherRules: {
        teacherName: [
          {required: true, message: '请输入姓名', trigger: 'submit'},
          {min: 1, max: 10, message: '姓名不能超过10个文字', trigger: 'submit'},
        ],
        teacherIdCardNo:[
          {required: true, message: '请输入身份证号', trigger: 'submit'},
          {min: 18, max: 18, message: '您输入的身份证号有误', trigger: 'submit'},
          {
            pattern:
              /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '您输入的身份证号码有误',
            trigger: 'submit'
          },
        ],
        teacherSchoolName: [
          {required: true, message: '请输入学校', trigger: 'submit'},
          {min: 1, max: 20, message: '学院不能超过20个文字', trigger: 'submit'},
        ],
        teacherCollege: [
          {required: true, message: '请输入学院', trigger: 'submit'},
          {min: 1, max: 20, message: '学院不能超过20个文字', trigger: 'submit'},
        ],
        teacherFieldName: [
          {required: true, message: '请输入专业', trigger: 'submit'},
          {min: 1, max: 20, message: '专业不能超过20个文字', trigger: 'submit'},
        ],
        teacherEmail: [
          {required: true, message: '请输入邮箱', trigger: 'submit'},
          // {
          //   pattern:
          //     /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
          //   message: '您输入的邮箱有误,请检查', trigger: 'submit'
          // },
        ],
        teacherTitle: [
          {required: true, message: '请输入职称', trigger: 'submit'},
          {min: 1, max: 10, message: '职称不能超过10个文字', trigger: 'submit'},
        ],
      },
      memberRules: {
        teamName: [
          {required: true, message: '请输入团队名称', trigger: 'submit'},
          {min: 1, max: 20, message: '团队名称不能超过20个文字', trigger: 'submit'},
        ],
      },
      memberDialogRules: {
        memberName: [
          {required: true, message: '请输入姓名', trigger: 'submit'},
          {min: 1, max: 10, message: '姓名不能超过10个文字', trigger: 'submit'},
        ],
        idCardNo: [
          {required: true, message: '请输入身份证号', trigger: 'submit'},
          {min: 18, max: 18, message: '您输入的身份证号有误', trigger: 'submit'},
          {
            pattern:
              /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '您输入的身份证号码有误',
            trigger: 'submit'
          },
        ],
        phone: [
          {required: true, message: '请输入手机号码', trigger: 'submit'},
          {min: 11, max: 11, message: '您输入的手机号有误', trigger: 'submit'},
         /* {pattern: /^1[3|4|5|8][0-9]\d{4,8}$/, message: '您输入的手机号有误', trigger: 'submit'},*/
        ],
        email: [
          {required: true, message: '请输入邮箱', trigger: 'submit'},
          // {
          //   pattern:
          //     /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
          //   message: '您输入的邮箱有误,请检查', trigger: 'submit'
          // },
        ],
        schoolName: [
          {required: true, message: '请输入学校', trigger: 'submit'},
          {min: 1, max: 20, message: '学校不能超过20个文字', trigger: 'submit'},
        ],
        college: [
          {required: true, message: '请输入学院', trigger: 'submit'},
          {min: 1, max: 20, message: '学院不能超过20个文字', trigger: 'submit'},
        ],
        grade: [
          {required: true, message: '请输入年级', trigger: 'submit'},
          {min: 1, max: 20, message: '年级不能超过20个文字', trigger: 'submit'},
        ],
        fieldName: [
          {required: true, message: '请输入专业', trigger: 'submit'},
          {min: 1, max: 20, message: '专业不能超过20个文字', trigger: 'submit'},
        ]
      },
      teacherDialogTitle: "",//导师弹出框的title
      teacherDialog: "",//添加导师的弹出框
      teacherFlag: 1,//导师添加或者修改 1代表添加  2代表修改
      teacherEditRowIndex: '',//导师table编辑行的下标

      memberDialogTitle: "",//成员弹出框的title
      memberDialog: false,//添加成员的弹出框
      memberFlag: 1,//成员添加或者修改 1代表添加  2代表修改
      memberEditRowIndex: '',//成员table编辑行的下标


      // enterForSuccessDiv: false,//报名成功弹出div //2026-1-19 xy注释 没地方用
      isEnterFor: false,//是否选中大赛规则
      enterForDisabled: true,//报名按钮是否灰化

      certificateReason: "",//拒绝原因
      enterForTitle: "报名",//是报名还是修改报名

      gameItemText:'',//参赛栏目的中文名
      isEnterForClose:true,
      isEnterForClose1:false,
      thesisOneForm: {//第一阶段提交投稿信息
        chName: "",
        enName: "",
        chKeyWords1: "",
        chKeyWords2: "",
        chKeyWords3: "",
        chKeyWords4: "",
        chKeyWords5: "",
        enKeyWords1: "",
        enKeyWords2: "",
        enKeyWords3: "",
        enKeyWords4: "",
        enKeyWords5: "",
      },
      thesisOneResultForm: {
        chName: "",
        enName: "",
        chKeyWords: "",
        enKeyWords: "",
        abstractOriginalName: "",
        refereeOpinionInfoFirst: "",//第一阶段评语
      },
      thesisOneRules: {
        chName: [
          {required: true, message: '请输入中文名称', trigger: 'submit'},
          {min: 1, max: 500, message: '中文名称不能超过500个文字', trigger: 'submit'},
        ],
        enName: [
          {required: true, message: '请输入英文名称', trigger: 'submit'},
          {min: 1, max: 500, message: '英文名称不能超过500个字母', trigger: 'submit'},
        ],
        chKeyWords1: [
          {required: true, message: '请输入关键字', trigger: 'submit'},
          {min: 1, max: 50, message: '单个关键字不能超过50个文字', trigger: 'submit'},
        ],
        chKeyWords2: [
          {required: true, message: '请输入关键字', trigger: 'submit'},
          {min: 1, max: 50, message: '单个关键字不能超过50个文字', trigger: 'submit'},
        ],
        chKeyWords3: [
          {required: true, message: '请输入关键字', trigger: 'submit'},
          {min: 1, max: 50, message: '单个关键字不能超过50个文字', trigger: 'submit'},
        ],
        chKeyWords4: [
          {required: true, message: '请输入关键字', trigger: 'submit'},
          {min: 1, max: 50, message: '单个关键字不能超过50个文字', trigger: 'submit'},
        ],
        chKeyWords5: [
          {required: true, message: '请输入关键字', trigger: 'submit'},
          {min: 1, max: 50, message: '单个关键字不能超过50个文字', trigger: 'submit'},
        ],
        enKeyWords1: [
          {required: true, message: '请输入关键字', trigger: 'submit'},
          {min: 1, max: 50, message: '单个关键字不能超过50个英文字母', trigger: 'submit'},
        ],
        enKeyWords2: [
          {required: true, message: '请输入关键字', trigger: 'submit'},
          {min: 1, max: 50, message: '单个关键字不能超过50个英文字母', trigger: 'submit'},
        ],
        enKeyWords3: [
          {required: true, message: '请输入关键字', trigger: 'submit'},
          {min: 1, max: 50, message: '单个关键字不能超过50个英文字母', trigger: 'submit'},
        ],
        enKeyWords4: [
          {required: true, message: '请输入关键字', trigger: 'submit'},
          {min: 1, max: 50, message: '单个关键字不能超过50个英文字母', trigger: 'submit'},
        ],
        enKeyWords5: [
          {required: true, message: '请输入关键字', trigger: 'submit'},
          {min: 1, max: 50, message: '单个关键字不能超过50个英文字母', trigger: 'submit'},
        ],
      },
      oneFileName: '',
      oneFile: '',
      oneDisabled:false,
      enterLoading:false,//报名按钮的loading控制
      refereeStatusFirst:'',//当前摘要报名状态 NODATA REFEREEING APPROVED REFUSED
      teamGrade:'',//UNDERGRADE 本科生组   MASTER 研究生租
    }
  },
  methods: {

    /**
     * table 的表头样式
     * @param rowIndex
     * @returns {string}
     */
    getHeaderStyle({rowIndex}) {
      if (rowIndex === 0) {
        return 'background:#405AA7;color: #fff'
      } else {
        return ''
      }
    },

    //更新input框的数据
    change(e) {
      this.$forceUpdate()//(固定语法)
    },

    /**
     * 复选框改变状态时触发
     */
    checkboxChange(status) {
      if (status) {
        this.enterForDisabled = false
      } else {
        this.enterForDisabled = true
      }
    },

    /**
     * 添加成员
     */
    addMember() {
      if (this.memberData.length >= 6) {
        promptData("最多填写六名成员!", this)
        return
      }
      // this.memberDialogForm = {}
      this.memberDialogForm = {
        memberRole: "成员",
        memberName: "",
        idCardNo: "",
        phone: "",
        email: "",
        schoolName: "",
        college: "",
        grade: "",
        fieldName: "",
      }
      this.memberDialogTitle = "添加成员信息"
      this.memberFlag = 1//1代表添加  2代表修改
      // this.memberDialogForm.memberRole = "成员"
      this.memberDialog = true
    },

    /**
     * 编辑成员
     * @param row 行信息
     */
    editMember(index, row) {
      this.memberEditRowIndex = index
      this.memberDialogTitle = "编辑成员信息"
      this.memberFlag = 2//1代表添加  2代表修改
      this.memberDialogForm.memberRole = row.memberRole
      // this.$set(this.memberDialogForm,'memberName',row.memberName)
      this.memberDialogForm.memberName = row.memberName
      this.memberDialogForm.idCardNo = row.idCardNo
      this.memberDialogForm.phone = row.phone
      this.memberDialogForm.email = row.email
      this.memberDialogForm.schoolName = row.schoolName
      this.memberDialogForm.college = row.college
      this.memberDialogForm.grade = gradeStringToEnum(row.grade)
      this.memberDialogForm.fieldName = row.fieldName
      this.memberDialog = true
    },

    /**
     * 删除一个成员信息
     * @param index 下标
     * @param row 删除行
     */
    deleteMember(index, row) {
      if (row.memberRole === "队长") {
        promptData("队长信息不允许删除!", this)
        return
      }
      this.memberData.splice(index, 1)
    },

    /**
     * 保存添加成员的信息
     * @param formName 表单名称
     */
    saveMember(formName) {
      let vue = this
      this.$refs[formName].validate((valid) => {
          if (valid) {
            let obj = {}
            obj.memberRole = vue.memberDialogForm.memberRole
            obj.memberName = vue.memberDialogForm.memberName
            obj.idCardNo = vue.memberDialogForm.idCardNo
            obj.phone = vue.memberDialogForm.phone
            obj.email = vue.memberDialogForm.email
            obj.schoolName = vue.memberDialogForm.schoolName
            obj.college = vue.memberDialogForm.college
            obj.grade = gradeEnumToString(vue.memberDialogForm.grade)
            obj.fieldName = vue.memberDialogForm.fieldName
            if (vue.memberFlag === 1) {//添加
              vue.memberData.push(obj)
            } else {
              vue.memberData[vue.memberEditRowIndex] = obj
              vue.memberData = JSON.parse(JSON.stringify(vue.memberData))//不知道赋值为什么赋不进去
            }
            vue.memberDialog = false
          }
        }
      );
    },

    /**
     * 添加老师
     */
    addTeacher() {
      if (this.teacherData.length >= 2) {
        promptData("最多填写两名老师!", this)
        return
      }
      this.teacherForm = {}
      this.teacherDialogTitle = "添加导师信息"
      this.teacherFlag = 1//1代表添加  2代表修改
      this.teacherDialog = true
    },

    /**
     * 编辑导师所选信息
     * @param index
     * @param row
     */
    editTeacher(index, row) {
      this.teacherEditRowIndex = index
      this.teacherDialogTitle = "编辑导师信息"
      this.teacherFlag = 2//1代表添加  2代表修改
      this.teacherDialog = true
      this.teacherForm.teacherName = row.teacherName
      this.teacherForm.teacherIdCardNo = row.teacherIdCardNo
      this.teacherForm.teacherEmail = row.teacherEmail
      this.teacherForm.teacherSchoolName = row.teacherSchoolName
      this.teacherForm.teacherCollege = row.teacherCollege
      this.teacherForm.teacherFieldName = row.teacherFieldName
      this.teacherForm.teacherTitle = row.teacherTitle
    },

    /**
     * 删除一个成员信息
     * @param index 下标
     * @param row 删除行
     */
    deleteTeacher(index, row) {
      this.teacherData.splice(index, 1)
    },

    /**
     * 保存老师
     * @param formName 表单
     */
    saveTeacher(formName) {
      let vue = this
      this.$refs[formName].validate((valid) => {
          if (valid) {
            let obj = {}
            obj.teacherName = vue.teacherForm.teacherName
            obj.teacherIdCardNo = vue.teacherForm.teacherIdCardNo
            obj.teacherEmail = vue.teacherForm.teacherEmail
            obj.teacherSchoolName = vue.teacherForm.teacherSchoolName
            obj.teacherCollege = vue.teacherForm.teacherCollege
            obj.teacherFieldName = vue.teacherForm.teacherFieldName
            obj.teacherTitle = vue.teacherForm.teacherTitle
            if (vue.teacherFlag === 1) {//添加
              vue.teacherData.push(obj)
            } else {
              vue.teacherData[vue.teacherEditRowIndex] = obj
              vue.teacherData = JSON.parse(JSON.stringify(vue.teacherData))//不知道赋值为什么赋不进去
            }
            vue.teacherDialog = false
          }
        }
      );
    },

    /**
     * 查看规则条例
     */
    thesisRule() {
      let id = '1'
      let routeUrl = this.$router.resolve({
        path: '/hot_inform?id=' + id,
      });
      window.open(routeUrl.href, '_blank');
    },

    /**
     * 确认报名
     */
    enterFor() {
      let vue = this

   /*   for (let p = 0; p < this.memberData.length; p++) {
        this.memberData[p].grade = gradeStringToEnum(this.memberData[p].grade)
      }*/

      let memberData = $.extend(true, [], this.memberData)//深拷贝

      for (let p = 0; p < memberData.length; p++) {
        memberData[p].grade = gradeStringToEnum(memberData[p].grade)
      }
      let captain = memberData[0]
      memberData.splice(0, 1)
      if (this.teacherData.length === 0) {
        promptData("请填写导师信息!", this)
        return;
      }
      let certificateInfo = {}
      if (captain.memberName === undefined || captain.memberName.trim() === "" || captain.memberName == null) {
        promptData("队长姓名不能为空!", this)
        return
      }
      if (this.playerForm.teamName === undefined || this.playerForm.teamName.trim() === "" || this.playerForm.teamName == null) {
        promptData("团队名称不能为空!", this)
        return
      }
      certificateInfo.teamName = this.playerForm.teamName
      certificateInfo.gameItem = this.playerForm.gameItem

      certificateInfo.uploadTime = new Date()

      certificateInfo.leaderName = captain.memberName//队长信息
      certificateInfo.leaderIdCardNo = captain.idCardNo
      certificateInfo.leaderPhone = captain.phone
      certificateInfo.leaderEmail = captain.email
      certificateInfo.leaderSchoolName = captain.schoolName
      certificateInfo.leaderCollege = captain.college
      certificateInfo.leaderGrade = captain.grade
      certificateInfo.leaderFieldName = captain.fieldName

      memberData.forEach(item=>{
        // 第四届最新的报名接口不需要这个字段
        delete item.memberRole
      })
      certificateInfo.memberInfos = memberData   //成员信息

      certificateInfo.teacherInfos = this.teacherData

      //查找身份证号是否有一样的
      let cardIds = []
      for (let k = 0; k < memberData.length; k++) {
        cardIds.push(memberData[k].idCardNo)
      }

      for (let p = 0; p < cardIds.length - 1; p++) {
        if (cardIds[p] === cardIds[p + 1]) {
          promptData("成员身份证不能相同!", this)
          return;
        }
      }

      // 旧版（第三届）
      // api.enterFor.enterForData(certificateInfo).then(function (response) {
      //   if (response == null) {
      //     return
      //   }
      //   if (response.data.code === '0') {
      //     //vue.playerForm.gameItem = gameItemEnumToString(vue.playerForm.gameItem)
      //     //vue.playerForm.gameItem = gameItemEnumToString(vue.playerForm.gameItem)
      //    /* for (let p = 0; p < vue.memberData.length; p++) {
      //       vue.memberData[p].grade = gradeEnumToString(vue.memberData[p].grade)
      //     }*/
      //     router.app.$options.store.state.user.certificateStatus = 'CERTIFICATING';
      //     // vue.enterForTitle = "修改报名"
      //     successPromptData("报名信息上传成功!", vue)
      //   }
      // })

      //获取需要上传的论文信息
      this.$refs['thesisOneForm'].validate((valid) => {
          if (valid) {
            let chName = vue.thesisOneForm.chName
            let enName = vue.thesisOneForm.enName
            let chKeyWords = vue.thesisOneForm.chKeyWords1 + "," + vue.thesisOneForm.chKeyWords2 + "," + vue.thesisOneForm.chKeyWords3 + "," + vue.thesisOneForm.chKeyWords4 + "," + vue.thesisOneForm.chKeyWords5
            let enKeyWords = vue.thesisOneForm.enKeyWords1 + "," + vue.thesisOneForm.enKeyWords2 + "," + vue.thesisOneForm.enKeyWords3 + "," + vue.thesisOneForm.enKeyWords4 + "," + vue.thesisOneForm.enKeyWords5
            let thesisInfo = {}
            thesisInfo.chName = chName
            thesisInfo.enName = enName
            thesisInfo.chKeyWords = chKeyWords
            thesisInfo.enKeyWords = enKeyWords
            thesisInfo.file = this.oneFile
            //新版（第四届）
            this.oneDisabled = true
            this.enterLoading = true
            api.enterFor.sendCertificateInfo(certificateInfo,thesisInfo).then((response)=>{
              vue.enterLoading = false
              vue.oneDisabled = false
              if (response == null) {
                return
              }
              if (response.data.code === '0') {
                let obj = JSON.parse(JSON.stringify(thesisInfo))
                delete obj.file
                obj.abstractOriginalName = vue.oneFileName
                //报名成功后展示论文信息
                this.giveOneResultValue(obj)
                //用户状态自动通过
                this.$store.state.user.certificateStatus = 'APPROVED';
                this.refereeStatusFirst = 'REFEREEING'
                // vue.enterForTitle = "修改报名"
                successPromptData("报名和摘要信息上传成功!", vue)
                // this.oneFile = ''
              }
            }).catch((err)=>{ 
              vue.enterLoading = false 
              vue.oneDisabled = false
            })
          } else {
            vue.oneDisabled = false
          }
        }
      );

    },

    /**
     * 上传文件的回调
     * @param {*} file 
     * @returns 
     */
    beforeAvatarUpload1(file) {
      let n = file.name.lastIndexOf(".");
      let suffix = file.name.substr(n + 1);
      if (suffix !== "zip" && suffix !== "rar") {
        this.$message.error('请上传zip/rar格式的压缩文件!');
        return
      }
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isLt2M) {
        this.$message.error('第一阶段上传文件不能超过 10MB!');
        return
      }
      this.oneFile = file
      this.oneFileName = file.name
      return
    },

    /**
     * 给第一阶段赋值
     * @param result
     */
    giveOneResultValue(result) {
      this.thesisOneResultForm.chName = result.chName
      this.thesisOneResultForm.enName = result.enName
      let splits = result.chKeyWords.split(",")
      let splits1 = result.enKeyWords.split(",")
      let chKeyWords = ""
      for (let i = 0; i < splits.length; i++) {
        if (splits[i].trim() === "") {
          continue
        } else {
          chKeyWords += splits[i] + ","
        }
      }
      let enKeyWords = ""
      for (let j = 0; j < splits1.length; j++) {
        if (splits1[j].trim() === "") {
          continue
        } else {
          enKeyWords += splits1[j] + ","
        }
      }
      chKeyWords = chKeyWords.substring(0, chKeyWords.lastIndexOf(","));
      enKeyWords = enKeyWords.substring(0, enKeyWords.lastIndexOf(","));
      this.thesisOneResultForm.chKeyWords = chKeyWords
      this.thesisOneResultForm.enKeyWords = enKeyWords
      this.thesisOneResultForm.abstractOriginalName = result.abstractOriginalName
      this.thesisOneResultForm.refereeOpinionInfoFirst = result.refereeOpinionInfoFirst
    },
  },

  created() {
    let vue = this
    vue.options = getGameItemOption()
    this.memberData = []
    switch (this.user.certificateStatus) {
      case 'NODATA'://未报名
        this.refereeStatusFirst = 'NODATA'
        this.isEnterForClose = true
        this.isEnterForClose1 = false
        let captainData = {}
        captainData.memberRole = '队长'
        captainData.memberName = ''
        captainData.idCardNo = ''
        captainData.phone = ''
        captainData.email = ''
        captainData.schoolName = ''
        captainData.college = ''
        captainData.grade = ''
        captainData.fieldName = ''
        let array = []
        array.push(captainData)
        this.memberData = array
        vue.enterForTitle = "报名"
        break
      default:
        let certificate= router.app.$options.store.state.certificate
        if(certificate===0){
          this.isEnterForClose1 = true
          this.isEnterForClose = false
        }else{
          this.isEnterForClose = true
          this.isEnterForClose1 = false
        }
        // vue.enterForTitle = "修改报名"
        api.enterFor.getThesisAbstractVOByUserId().then(function (response) {
          if (response == null) {
            return
          }
          if (response.data.code === '0') {
            let result = response.data.result
            let teamInfo = result.certificateInfo
            vue.refereeStatusFirst = result.refereeStatusFirst
            if(!teamInfo)return
            vue.teamGrade = teamInfo.teamGrade == 'MASTER' ? '研究生组' : '本科生组'
            vue.playerForm.teamName = teamInfo.teamName
            vue.playerForm.gameItem = teamInfo.gameItem
            vue.gameItemText =gameItemEnumToString(teamInfo.gameItem)
            vue.memberData = []
            let obj = {}
            obj.memberRole = '队长'
            obj.memberName = teamInfo.leaderName //队长信息
            obj.idCardNo = teamInfo.leaderIdCardNo
            obj.phone = teamInfo.leaderPhone
            obj.email = teamInfo.leaderEmail
            obj.schoolName = teamInfo.leaderSchoolName
            obj.college = teamInfo.leaderCollege
            obj.grade = gradeEnumToString(teamInfo.leaderGrade)
            obj.fieldName = teamInfo.leaderFieldName
            vue.memberData.push(obj)
            if (teamInfo.memberInfos != null) {
              for (let i = 0; i < teamInfo.memberInfos.length; i++) {
                teamInfo.memberInfos[i].memberRole = '队员'
                teamInfo.memberInfos[i].grade = gradeEnumToString(teamInfo.memberInfos[i].grade)
                vue.memberData.push(teamInfo.memberInfos[i])
              }
            }
            vue.certificateReason = teamInfo.certificateReason
            vue.teacherData = teamInfo.teacherInfos
            vue.giveOneResultValue(result)

          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/EnterFor/EnterFor.js